export default __webpack_public_path__ + "static/media/risk_low.bfc678a1.svg";